import React, { Component } from 'react';
import { connect } from 'react-redux';

import { evAddPaymentInstrumentClick, evDeletePaymentOption, evMakePaymentOptionPrimary, evPaymentsPageView } from 'events/account';
import { deletePaymentInfo, fetchPaymentInfo, makePrimary } from 'actions/account/payment';
import { checkCustomerAuthentication } from 'actions/authentication';
import { firePixelServer } from 'actions/pixelServer';
import PaymentCardLayout from 'components/account/PaymentCardLayout';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import AccountHeader from 'containers/account/AccountHeader';
import AccountBreadcrumbs from 'components/account/AccountBreadcrumbs';
import BackNav from 'components/account/BackNav';
import { PageLoader } from 'components/Loader';
import { titaniteView, track } from 'apis/amethyst';
import { PAGE_TYPE_MAP } from 'helpers/analytics';
import { cn } from 'helpers/classnames';
import withUseMyAccountRedesignHOC from 'helpers/useMyAccountRedesignHOCWrapper';

import styles from 'styles/containers/account/payments.scss';

export class Payments extends Component {
  componentDidMount() {
    titaniteView();

    const {
      firePixelServer,
      checkCustomerAuthentication,
      payment: { paymentInstruments }
    } = this.props;
    const returnTo = '/payments';

    if (paymentInstruments) {
      this.firePageLoadTracking(paymentInstruments);
    }

    checkCustomerAuthentication(returnTo, () => this.fetchData(), {
      redirectOnClose: '/'
    });
    firePixelServer('my-account', {}, 'payment-list');
  }

  componentDidUpdate(prevProps) {
    const {
      payment: { paymentInstruments: prevPaymentInstruments }
    } = prevProps;
    const {
      payment: { paymentInstruments }
    } = this.props;

    if (paymentInstruments && prevPaymentInstruments === null) {
      this.firePageLoadTracking(paymentInstruments);
    }
  }

  firePageLoadTracking(paymentInstruments) {
    const hasDefaultPaymentInstrument = paymentInstruments.some(payment => payment.primaryPaymentMethod);
    track(() => [
      evPaymentsPageView,
      {
        numberOfPaymentInstruments: paymentInstruments.length,
        hasDefaultPaymentInstrument
      }
    ]);
  }

  fetchData() {
    const {
      payment: { paymentInstruments },
      fetchPaymentInfo
    } = this.props;

    if (!paymentInstruments) {
      fetchPaymentInfo(null, '/payments');
    }
  }

  handleAddNewPayment = () => {
    track(() => [evAddPaymentInstrumentClick, { sourcePage: 7 }]);
  };

  handleDelete = ({ paymentInstrumentId }, win = window) => {
    const { deletePaymentInfo } = this.props;
    track(() => [evDeletePaymentOption, { paymentInstrumentId }]);
    deletePaymentInfo(paymentInstrumentId);
    win.scrollTo(0, 0);
  };

  handleMakePrimary = ({ fullName, paymentInstrumentId }, win = window) => {
    const { makePrimary } = this.props;
    track(() => [evMakePaymentOptionPrimary, { paymentInstrumentId, sourcePage: PAGE_TYPE_MAP.account }]);
    makePrimary(fullName, paymentInstrumentId);
    win.scrollTo(0, 0);
  };

  render() {
    const {
      payment: { paymentInstruments, isLoading }
    } = this.props;

    if (!paymentInstruments || isLoading) {
      return <PageLoader centered={true} />;
    }

    return (
      <SiteAwareMetadata>
        <div className={cn(styles.payments, { [styles.adjustMarginAndPaddingNewDesign]: this.props.isMyAccRedesign })}>
          <div className={styles.header}>
            <AccountBreadcrumbs currentText="Payment Information" homeLinkName={this.props.isMyAccRedesign ? 'Account' : 'Account Overview'} />
            <BackNav to="/account">My Account</BackNav>
            <AccountHeader title="Payment Information" />
          </div>
          <PaymentCardLayout
            paymentInstruments={paymentInstruments}
            onPrimary={this.handleMakePrimary}
            onDelete={this.handleDelete}
            onAddNewPayment={this.handleAddNewPayment}
          />
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment
});

export default connect(mapStateToProps, {
  fetchPaymentInfo,
  firePixelServer,
  deletePaymentInfo,
  makePrimary,
  checkCustomerAuthentication
})(withUseMyAccountRedesignHOC(Payments, 'isMyAccRedesignHookValue'));
